import { AbsoluteCropParameters, RelativeCropParameters } from "app/helpers/CropHelper"
import { ButtonSelection } from "./types"
import * as params from "./params"
import * as aspect from "./aspect"
import * as resizers from "./resizers"

const imageViewBoxWidth = 1600
const imageViewBoxHeight = 900

export const append = (buttonElement) => {
  const svgContainer = buttonElement
    .append("svg")
    // use this to select the "rect", "ellipse" and "image" part of a button
    .classed("dashboard-button", true)
    .classed("dashboard-button-image", true)
    .attr("preserveAspectRatio", "none")
    .style("display", "none")
  svgContainer
    .append("image")
    .classed("dashboard-button-image-crop", true)
    .attr("preserveAspectRatio", "none")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", "100%")
    .attr("height", "100%")
  computeAttributes(buttonElement)
}

export const computeAttributes = (buttonElement) => {
  const datum = buttonElement.datum()
  buttonElement
    .selectAll(".dashboard-button-image")
    .attr("width", datum.width)
    .attr("height", datum.height)
}

export const setImage = (
  buttonElement: ButtonSelection,
  href: string | undefined,
  width?: number,
  height?: number,
) => {
  const imageElement = buttonElement.select(".dashboard-button-image-crop")
  if (imageElement.size()) {
    if (href) {
      imageElement.attr("href", href)
    } else {
      imageElement.attr("href", null)
    }
    if (width && height) {
      buttonElement.attr("image-width", width)
      buttonElement.attr("image-height", height)
    }
    // resize the button to match the new aspect ratio
    buttonElement.datum((datum) => ({
      ...datum,
      ...aspect.enforce(
        { x: datum.x, y: datum.y, width: datum.width, height: datum.height },
        { top: false, right: true, bottom: true, left: false },
        { width: Number(width), height: Number(height) },
      ),
    }))
    resizers.snapToGridAfterResize(buttonElement, {
      top: false,
      right: true,
      bottom: true,
      left: false,
    })
  }
  return undefined
}

export const getImage = (buttonElement: ButtonSelection): string | undefined => {
  const imageElement = buttonElement.select(".dashboard-button-image-crop")
  if (imageElement.size()) {
    return imageElement.attr("href") || undefined
  }
  return undefined
}

export const setCrop = (buttonElement: ButtonSelection, crop: RelativeCropParameters) => {
  buttonElement
    .selectAll(".dashboard-button-image-crop")
    .attr("x", `${(-crop.x / crop.width) * params.width}`)
    .attr("y", `${(-crop.y / crop.height) * params.height}`)
    .attr("width", `${imageViewBoxWidth / crop.width}`)
    .attr("height", `${imageViewBoxHeight / crop.height}`)
}

export const getCrop = (buttonElement: ButtonSelection): AbsoluteCropParameters | undefined => {
  const image = buttonElement.select(".dashboard-button-image-crop")
  if (image.size()) {
    const width = Number(image.attr("width") || imageViewBoxWidth)
    const height = Number(image.attr("height") || imageViewBoxHeight)
    return {
      x: (Number(image.attr("x") || "0") * width) / imageViewBoxWidth,
      y: (Number(image.attr("y") || "0") * height) / imageViewBoxHeight,
      width: Number(image.attr("width") || imageViewBoxWidth),
      height: Number(image.attr("height") || imageViewBoxHeight),
      imgWidth: imageViewBoxWidth,
      imgHeight: imageViewBoxHeight,
    }
  } else {
    return undefined
  }
}
